import { Component, h, Prop, State } from '@stencil/core';
import state from '@ugc-store';
import { FontType, isRtl, PageType } from '@ugc-utils/utils';

const defaultStaticLanguage = {
  IDS_UGC_HEALTH_CLAIM_DISCLAIMER: '',
  IDS_GEN_DISCLAIMER: '',
  IDS_FDA_DISCLAIMER: '',
  IDS_LNK_CLOSE: '',
  IDS_UGC_ANSWERS_DISCLAIMER: '',
};

@Component({
  tag: 'ugc-medical-disclaimer',
  shadow: false,
})
export class UgcMedicalDisclaimer {
  @Prop() pageType?: PageType = PageType.review;
  @Prop() fontType: FontType = FontType.large;
  @State() tooltipName: string = 'disclaimer';

  render() {
    const data = () => {
      if (this.pageType === PageType.review) {
        this.tooltipName = 'review-disclaimer';
        return state.reviewStaticLanguage;
      }
      if (this.pageType === PageType.qna) {
        this.tooltipName = 'qna-disclaimer';
        return state.qnaStaticLanguage;
      }
      return defaultStaticLanguage;
    };

    const {
      IDS_UGC_HEALTH_CLAIM_DISCLAIMER = '',
      IDS_GEN_DISCLAIMER = '',
      IDS_FDA_DISCLAIMER = '',
      IDS_LNK_CLOSE = '',
      IDS_UGC_ANSWERS_DISCLAIMER = '',
    } = data();

    const fontType = this.fontType === FontType.large ? 'fs-14' : 'fs-12';

    const content = this.pageType === PageType.qna ? IDS_UGC_ANSWERS_DISCLAIMER : IDS_FDA_DISCLAIMER;

    return (
      <div class={`${fontType} lh-16 color-gray-600 flex-row-start-start gap-4`}>
        <span class="lh-20">
          <span class={`color-orange-standard ${isRtl() ? 'ml-4' : 'mr-4'}`}>{IDS_GEN_DISCLAIMER}:</span>
          {IDS_UGC_HEALTH_CLAIM_DISCLAIMER}
        </span>

        {content && (
          <ugc-info-tooltip
            header={IDS_GEN_DISCLAIMER}
            content={this.pageType === PageType.qna ? IDS_UGC_ANSWERS_DISCLAIMER : IDS_FDA_DISCLAIMER}
            closeText={IDS_LNK_CLOSE}
            tooltipName={this.tooltipName}
          />
        )}
      </div>
    );
  }
}
